"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _DistributionBadge = _interopRequireDefault(require("./DistributionBadge"));

require("./AudioPlayerPlaylistItem.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  _setPrototypeOf(subClass.prototype, superClass && superClass.prototype);

  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.getPrototypeOf || function _getPrototypeOf(o) {
    return o.__proto__;
  };

  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var AudioPlayerPlaylistItem =
/*#__PURE__*/
function (_React$PureComponent) {
  function AudioPlayerPlaylistItem(props) {
    var _this;

    _classCallCheck(this, AudioPlayerPlaylistItem);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AudioPlayerPlaylistItem).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      isSelected: false
    });

    _this.state.isSelected = props.selected;
    _this.handleSelect = _this.handleSelect.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.scrollIntoView = _this.scrollIntoView.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(AudioPlayerPlaylistItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var isSelected = this.state.isSelected;
      this.scrollIntoView(isSelected);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var isSelected = this.state.isSelected;
      this.scrollIntoView(isSelected && isSelected !== prevState.isSelected);
    }
  }, {
    key: "setIsSelected",
    value: function setIsSelected(isSelected) {
      this.setState({
        isSelected: isSelected
      });
    }
  }, {
    key: "scrollIntoView",
    value: function scrollIntoView(scroll) {
      if (scroll) {
        this.node.scrollIntoView();
      }
    }
  }, {
    key: "handleSelect",
    value: function handleSelect() {
      var _this$props = this.props,
          media = _this$props.media,
          onSelect = _this$props.onSelect;

      if (media.disabled) {
        return;
      }

      this.setState({
        isSelected: true
      });
      if (onSelect) onSelect(media._id);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props$media = this.props.media,
          _id = _this$props$media._id,
          author = _this$props$media.author,
          collection = _this$props$media.collection,
          projectThumbFileUrl = _this$props$media.projectThumbFileUrl,
          title = _this$props$media.title;
      var isSelected = this.state.isSelected;
      var userId = this.context.userId;
      var imgSrc = projectThumbFileUrl || "".concat(process.env.REACT_APP_PREFIX, "/iconTitled.png");
      return _react.default.createElement("div", {
        className: "song",
        onClick: this.handleSelect,
        onKeyUp: this.handleSelect,
        role: "button",
        tabIndex: 0,
        ref: function ref(node) {
          _this2.node = node;
        }
      }, _react.default.createElement("div", {
        className: "info"
      }, _react.default.createElement("div", {
        className: "img",
        style: {
          backgroundImage: "url('".concat(imgSrc, "')")
        }
      }, isSelected && _react.default.createElement("div", {
        className: "playing"
      }, _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _freeSolidSvgIcons.faAlignRight,
        rotation: 90
      }))), _react.default.createElement("div", {
        className: "titles"
      }, _react.default.createElement("h5", null, title), _react.default.createElement("p", null, author))), _react.default.createElement("div", {
        className: "h-100 pt-3"
      }, userId && _react.default.createElement(_DistributionBadge.default, {
        type: collection,
        contentId: _id,
        polling: isSelected
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref) {
      var selected = _ref.selected;
      return {
        isSelected: selected
      };
    }
  }]);

  _inherits(AudioPlayerPlaylistItem, _React$PureComponent);

  return AudioPlayerPlaylistItem;
}(_react.default.PureComponent);

exports.default = AudioPlayerPlaylistItem;

_defineProperty(_defineProperty(_defineProperty(AudioPlayerPlaylistItem, "propTypes", {
  media: _propTypes.default.object,
  onSelect: _propTypes.default.func,
  selected: _propTypes.default.bool
}), "contextTypes", {
  userId: _propTypes.default.string
}), "defaultProps", {
  media: {},
  onSelect: null,
  selected: false
});